import { useEffect } from 'react';

import { GamePlayerStatus } from '../../../Constants';


// Manual 3.1 opening ghost placement — headless dock-picker controller.
// Modeled on AddGhost2d. Mounts when a seat is in
// OPENING_GHOST_PLACEMENT_ID, highlights every dock, and on each click
// fires the existing per-click gamePlayerApi.placeGhost(dockIndex) —
// the same call AddGhost2d makes for the in-game Haunt action. The
// engine counts placements via attacking_ghosts and flips the seat to
// WAITING once it hits 0; the parent unmounts this component on that
// status change. No client-side accumulator, no batched commit.

const ALL_DOCK_INDICES = [0, 1, 2, 3];


function isActivePlacer(gamePlayerData) {
    if (!gamePlayerData) return false;
    return (gamePlayerData.status
        === GamePlayerStatus.OPENING_GHOST_PLACEMENT_ID);
}


function getGamePlayerApi(app) {
    const seated = app && app.game && app.game.seatedController;
    if (!seated) return null;
    return seated.gamePlayerApi || null;
}


export default function OpeningGhostPlacement(props) {
    const { app, gamePlayerData } = props;
    const active = isActivePlacer(gamePlayerData);

    useEffect(() => {
        if (!active) return undefined;

        function onClick(dockIndex) {
            const gamePlayerApi = getGamePlayerApi(app);
            if (gamePlayerApi) {
                gamePlayerApi.placeGhost(dockIndex);
            }
        }

        function highlightAllDocks() {
            window.dispatchEvent(new CustomEvent('highlight-docks-event', {
                detail: {
                    highlightedDocks: ALL_DOCK_INDICES,
                    callback: onClick,
                },
            }));
        }

        highlightAllDocks();
        window.addEventListener(
            'hotel-interface-mounted-event', highlightAllDocks);

        return () => {
            window.dispatchEvent(new Event('clear-docks-highlight-event'));
            window.removeEventListener(
                'hotel-interface-mounted-event', highlightAllDocks);
        };
    }, [active, app]);

    return null;
}
